import {
  type WorkerRequirementIncludedAutomatedNameUpdateType,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";

import { type OnboardingPersonalIdVerificationStep } from "./types";

export function getStepFromRequirementStatus(
  requirementStatus: WorkerRequirementStatus
): OnboardingPersonalIdVerificationStep {
  switch (requirementStatus) {
    case WorkerRequirementStatus.MISSING:
    case WorkerRequirementStatus.EXPIRED: {
      return "start-verification";
    }

    // ID is still valid, but expiring soon.
    // So we still want to show the approved stage in onboarding
    case WorkerRequirementStatus.EXPIRING:
    case WorkerRequirementStatus.APPROVED: {
      return "approved";
    }

    case WorkerRequirementStatus.IN_REVIEW:
    case WorkerRequirementStatus.REJECTED: {
      // It's possible for Personal ID to be rejected instantly. In this case we still want to show the in-review page.
      return "in-review";
    }

    default: {
      requirementStatus satisfies never; // Exhaustive type check to ensure all cases are handled
      return "start-verification";
    }
  }
}

/**
 * Returns the full previous and new names from the automated name update.
 *
 * Joins the first, middle, and last names with a space between them. Removes empty strings.
 */
export function getNamesFromAutomatedNameUpdate(
  automatedNameUpdate: WorkerRequirementIncludedAutomatedNameUpdateType
): {
  previousName: string;
  newName: string;
} {
  return {
    previousName: [
      automatedNameUpdate.attributes.previousFirstName,
      automatedNameUpdate.attributes.previousMiddleName,
      automatedNameUpdate.attributes.previousLastName,
    ]
      .filter(Boolean) // Remove empty strings
      .join(" "),
    newName: [
      automatedNameUpdate.attributes.newFirstName,
      automatedNameUpdate.attributes.newMiddleName,
      automatedNameUpdate.attributes.newLastName,
    ]
      .filter(Boolean)
      .join(" "),
  };
}
